import { FontTTHoves } from '@m/assets/fonts/tt-hoves/FontTTHoves';
import MaintenancePage from '@m/components/MaintenancePage/MaintenancePage';
import { MAINTENANCE_MODE } from '@m/constants/FeatureFlags';
import { BrowserRouter } from 'react-router-dom';

import SharedProviders from './shared';

export default function Providers({ children }: { children?: React.ReactNode }) {
  return (
    <SharedProviders>
      <FontTTHoves />
      {MAINTENANCE_MODE ? <MaintenancePage /> : <BrowserRouter>{children}</BrowserRouter>}
    </SharedProviders>
  );
}
